import { GetterTree } from "vuex";
import { ManualActionState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<ManualActionState, RootState> = {
    getManualPulseData: state => state.manualPulseData,
    getManualEventResetData: state => state.manualEventResetData
};